export default __webpack_public_path__ + "static/media/Mark-5-HUD-Suit Stats.1f48e9d4.jpg";